// mobile-nav.js
theme.headerSection = (function () {
  function header() {
    const MobileMenu = function () {
      const offcanvasOpen = document.querySelector(".header__actions_btn--menu");
      const offcanvasClose = document.querySelector(".offcanvas__close_btn");
      const offcanvasHeader = document.querySelector(".offcanvas-header");
      const offcanvasOverlay = document.querySelector(".offcanvas-overlay");
      const body = document.body;

      if (!offcanvasHeader) return;

      const rootList = offcanvasHeader.querySelector("[data-mobile-root-list]");
      const menuScroller = offcanvasHeader.querySelector(".offcanvas__menu");

      function scrollMenuTop(behavior) {
        menuScroller?.scrollTo({ top: 0, behavior: behavior || "instant" });
      }

      /* ---- Level 2: root item <-> its category panel ---- */

      function openRootPanel(item) {
        if (!item || !rootList) return;

        const trigger = item.querySelector("[data-mobile-root-open]");
        const panel = item.querySelector("[data-mobile-root-panel]");
        if (!panel) return;

        rootList.classList.add("is-drilled");
        item.classList.add("is-root-open");
        if (trigger) trigger.setAttribute("aria-expanded", "true");
        panel.hidden = false;

        scrollMenuTop("instant");
      }

      function closeRootPanel(item) {
        if (!item || !rootList) return;

        const trigger = item.querySelector("[data-mobile-root-open]");
        const panel = item.querySelector("[data-mobile-root-panel]");

        // Collapse any nested category drill-down first, so returning to
        // this root later starts fresh at the category list.
        item
          .querySelectorAll(".mobile-menu__category-item.is-child-open")
          .forEach(closeChildPanel);

        item.classList.remove("is-root-open");
        rootList.classList.remove("is-drilled");
        if (trigger) trigger.setAttribute("aria-expanded", "false");
        if (panel) panel.hidden = true;

        scrollMenuTop("instant");
      }

      /* ---- Level 3: category item <-> its grandchildren panel ---- */

      function openChildPanel(item) {
        const panel = item && item.querySelector("[data-mobile-child-panel]");
        const categoryList = item && item.closest("[data-mobile-categories-list]");
        if (!item || !panel || !categoryList) return;

        const trigger = item.querySelector("[data-mobile-child-toggle]");

        // Only one category can be drilled into at a time.
        categoryList
          .querySelectorAll(".mobile-menu__category-item.is-child-open")
          .forEach(function (openItem) {
            if (openItem !== item) closeChildPanel(openItem);
          });

        item.classList.add("is-child-open");
        categoryList.classList.add("is-child-drilled");
        if (trigger) trigger.setAttribute("aria-expanded", "true");
        panel.hidden = false;

        scrollMenuTop("smooth");
      }

      function closeChildPanel(item) {
        const panel = item && item.querySelector("[data-mobile-child-panel]");
        const categoryList = item && item.closest("[data-mobile-categories-list]");
        if (!item || !panel || !categoryList) return;

        const trigger = item.querySelector("[data-mobile-child-toggle]");

        item.classList.remove("is-child-open");
        categoryList.classList.remove("is-child-drilled");
        if (trigger) trigger.setAttribute("aria-expanded", "false");
        panel.hidden = true;

        scrollMenuTop("smooth");
      }

      /* ---- Whole-menu open/close/reset ---- */

      function resetMobileMenu() {
        if (!rootList) return;

        rootList
          .querySelectorAll(".mobile-menu__root-item.is-root-open")
          .forEach(closeRootPanel);
      }

      function openMenu() {
        resetMobileMenu();
        offcanvasHeader.classList.add("open");
        offcanvasHeader.setAttribute("aria-hidden", "false");
        body.style.overflowY = "hidden";
      }

      function closeMenu() {
        offcanvasHeader.classList.remove("open");
        offcanvasHeader.setAttribute("aria-hidden", "true");
        body.style.overflowY = "";
        resetMobileMenu();
      }

      if (offcanvasOpen) {
        offcanvasOpen.addEventListener("click", function (event) {
          event.preventDefault();
          openMenu();
        });
      }

      if (offcanvasClose) {
        offcanvasClose.addEventListener("click", function (event) {
          event.preventDefault();
          closeMenu();
        });
      }

      if (offcanvasOverlay) {
        offcanvasOverlay.addEventListener("click", closeMenu);
      }

      /* Forward: root -> categories */
      offcanvasHeader
        .querySelectorAll("[data-mobile-root-open]")
        .forEach(function (trigger) {
          trigger.addEventListener("click", function () {
            openRootPanel(trigger.closest(".mobile-menu__root-item"));
          });
        });

      /* Back: categories -> root */
      offcanvasHeader
        .querySelectorAll("[data-mobile-root-back]")
        .forEach(function (btn) {
          btn.addEventListener("click", function () {
            closeRootPanel(btn.closest(".mobile-menu__root-item"));
          });
        });

      /* Forward: category -> grandchildren */
      offcanvasHeader
        .querySelectorAll("[data-mobile-child-toggle]")
        .forEach(function (trigger) {
          trigger.addEventListener("click", function () {
            openChildPanel(trigger.closest(".mobile-menu__category-item"));
          });
        });

      /* Back: grandchildren -> categories */
      offcanvasHeader
        .querySelectorAll("[data-mobile-child-back]")
        .forEach(function (btn) {
          btn.addEventListener("click", function () {
            closeChildPanel(btn.closest(".mobile-menu__category-item"));
          });
        });

      /* Close when viewport returns to desktop. */
      window.addEventListener("resize", function () {
        if (window.innerWidth >= 992) {
          closeMenu();
        }
      });

      /* Escape steps back one level at a time; closes the drawer if already at root. */
      document.addEventListener("keydown", function (event) {
        if (event.key !== "Escape" || !offcanvasHeader.classList.contains("open")) {
          return;
        }

        const openChild = rootList?.querySelector(".mobile-menu__category-item.is-child-open");
        const openRoot = rootList?.querySelector(".mobile-menu__root-item.is-root-open");

        if (openChild) {
          closeChildPanel(openChild);
        } else if (openRoot) {
          closeRootPanel(openRoot);
        } else {
          closeMenu();
          offcanvasOpen?.focus();
        }
      });
    };

    function reuseFooterMascot() {
      const target = document.querySelector("[data-mobile-menu-mascot]");
      if (!target || target.children.length) return;

      const footerImageBlock = document.querySelector(
        'footer [data-block-type="image"]'
      );

      if (!footerImageBlock) return;

      const heading = footerImageBlock.querySelector(".footer-teddy-heading");
      const teddy = footerImageBlock.querySelector(".footer-block-image");

      /* Figma uses the existing "Little things / big joy" mark beside the teddy,
         so clone the heading and the animated teddy as two separate pieces. */
      if (heading) {
        const headingClone = heading.cloneNode(true);
        headingClone.classList.add("mobile-menu__footer-mascot-heading");
        headingClone.removeAttribute("id");
        target.appendChild(headingClone);
      }

      if (teddy) {
        const teddyClone = teddy.cloneNode(true);
        teddyClone.classList.add("mobile-menu__footer-mascot-clone");
        teddyClone.removeAttribute("id");
        target.appendChild(teddyClone);
      }
    }

    function initMobileCounts() {
      function numericCount(element) {
        if (!element) return 0;

        let node = element;

        if (element.classList.contains("cart-count-bubble")) {
          node =
            element.querySelector("[id^='cart-notification-count']") ||
            element.querySelector("span[aria-hidden='true']") ||
            element;
        }

        const match = String(node.textContent || "").match(/\d+/);
        return match ? Number(match[0]) : 0;
      }

      function refresh() {
        document
          .querySelectorAll(
            ".mobile__navigation--bar .wishlist__count, .mobile__navigation--bar .cart-count-bubble"
          )
          .forEach(function (badge) {
            const count = numericCount(badge);
            badge.classList.toggle("header-count--hidden", count < 1);
          });
      }

      refresh();

      const mobileBar = document.querySelector(".mobile__navigation--bar");
      if (!mobileBar) return;

      const observer = new MutationObserver(refresh);
      observer.observe(mobileBar, {
        childList: true,
        subtree: true,
        characterData: true,
      });
    }

    MobileMenu();
    reuseFooterMascot();
    initMobileCounts();
  }

  return header;
})();